import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { DealerPartsListviewModel } from '../business-entities/dealer-parts-list-view-model';
import { DealerPartSearchObj } from '../business-entities/dealer-part-search-object-view-model';

@Injectable({
  providedIn: 'root'
})
export class DealerPartsDataService {

  constructor(private dataProvider: DataService) { }

  async getDealerPartsListById(dealerId: string,LanguageCode:string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerPartsListById, dealerId,LanguageCode)
      .toPromise();
  }

  addDealerParts(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDealerParts, model).toPromise();
  }
  updateDealerParts(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateDealerParts, model).toPromise();
  }
  async getDealerPartById(viewmodel): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetDealerPartById, viewmodel).toPromise();
  }

  async getDealerAndPartSearch(searchObj: DealerPartSearchObj): Promise<GenericResponse<DealerPartsListviewModel>> {
    return this.dataProvider.Post<GenericResponse<DealerPartsListviewModel>>(Urls.GetDealerPartsSearch, searchObj).toPromise();
  }

}
